import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { PushIcon } from '@arcade/web/icons/react'
import { Flex } from '@cash-design-system/react'
import {
  CellDefaultCellDefaultAccessoryLabeledPush,
  CellDefaultCellDefaultAccessoryLeadingImage,
} from '@cash-web/protos/squareup/cash/ui/arcade/elements/CellDefault.pb'
import logger from '@cash-web/shared/util-logger'

import { ArcadeCellLabelAccessoryWrapper } from '../ArcadeCellLabelAccessoryWrapper/ArcadeCellLabelAccessoryWrapper'

const PushIconLabel = styled.span<{ disabled: boolean; colorOverride?: string }>`
  ${({ theme }) => theme.typography.body};
  color: ${({ theme, disabled, colorOverride }) => {
    if (colorOverride) {
      return colorOverride
    } else {
      return disabled ? theme.arcadeColors.component.cellLabelDisabled : theme.arcadeColors.component.cellLabelDefault
    }
  }};
`

export function ArcadeAccessoryLabeledPushFromProto({
  protoProps,
  accessoryLeadingImage,
  disabled = false,
}: {
  protoProps: CellDefaultCellDefaultAccessoryLabeledPush
  accessoryLeadingImage?: CellDefaultCellDefaultAccessoryLeadingImage
  disabled?: boolean
}) {
  const { darkMode } = useTheme()

  if (protoProps?.vertical_alignment) {
    logger.warn(new Error('ArcadeCellAccessoryFromProto: vertical_alignment not currently supported'))
  }

  const lightLabelColor = protoProps.text_color?.light?.srgb
  const darkLabelColor = protoProps.text_color?.dark?.srgb
  const labelColor = darkMode ? darkLabelColor ?? lightLabelColor : lightLabelColor

  return (
    <ArcadeCellLabelAccessoryWrapper accessoryLeadingImage={accessoryLeadingImage}>
      <Flex>
        <PushIconLabel disabled={disabled} colorOverride={labelColor}>
          {protoProps.text?.translated_value}
        </PushIconLabel>
        <PushIcon variant={disabled ? 'disabled' : 'standard'} />
      </Flex>
    </ArcadeCellLabelAccessoryWrapper>
  )
}
